import React from 'react'
import styled from 'styled-components'

const StyledMultiSelectMessage = styled.div`
    position: absolute;
    left: -9999px;
`

interface MultiSelectStatusProps {
    message: string
}

const MultiSelectStatus: React.FC<MultiSelectStatusProps> = ({message}) => (
    <StyledMultiSelectMessage role="status" aria-live="polite">
        {message}
    </StyledMultiSelectMessage>
)

export default MultiSelectStatus
